// A chart box on a slide (SD): its chart drawn in the box, in the deck's colours and fonts, the same in every place a
// slide shows. A linked chart draws the values kept with it (follow.ts keeps them current in the owner's tab), or, when
// its sheet or range is gone, says so in place of any number.

import type { SlideBox } from "../../../../shared/slideDesign";
import { fontStack } from "../../../../shared/slideDesign";
import type { BoxCtx } from "../Boxes";
import { CHART_SIZE, ChartSvg } from "./ChartView";

export function ChartBody({ box: b, ctx }: { box: SlideBox; ctx: BoxCtx }) {
  const c = b.chart!;
  const look = { palette: ctx.palette, font: fontStack(b.font, ctx.theme), titleFont: ctx.theme.title, size: b.size ?? CHART_SIZE };
  const note = c.lost ? { title: c.lost, body: ctx.mode === "edit" ? "Edit data links it again, or keeps the last numbers as typed ones." : undefined } : null;
  return <ChartSvg chart={c} w={b.w} h={b.h} look={look} note={note} />;
}
